<template>
  <div id="contenedor-listado-fianzas-contrato-mobile">
    <template v-for="(fianza, index) in listadoFianzas">
      <v-card :key="index" class="mb-3">
        <v-card dark flat :color="fianza.tipoDetalle.color" rounded="0">
          <v-card-title class="justify-center">
            <span class="font-weight-bold">{{fianza.tipoDetalle.nombre}}</span>
          </v-card-title>
        </v-card>
        <v-card-text>
          <v-row justify="space-between" class="my-2">
            <span class="secondary--text font-weight-bold" cols="12">
              Número:
            </span>
            <span>
              {{fianza.numero}}
            </span>
          </v-row>
          <v-row justify="space-between" class="my-2">
            <span class="secondary--text font-weight-bold" cols="12">
              Fecha:
            </span>
            <span>
              {{ new Date(`${fianza.fecha} 00:00:0`).toLocaleDateString() }}
            </span>
          </v-row>
          <v-row justify="space-between" class="my-2">
              <span class="secondary--text font-weight-bold" cols="12">
                Nombre de Afianzadora:
              </span>
              <span>
                {{fianza.nombreAfianzadora}}
              </span>
          </v-row>
          <v-row justify="space-between" class="my-2">
              <span class="secondary--text font-weight-bold" cols="12">
                Monto:
              </span>
              <span>
                {{fianza.monto | currency}}
              </span>
          </v-row>
        </v-card-text>
        <v-card-text>
          <v-row justify="center">
              <v-btn
                v-if="mixValidaScopesActions(3)"
                icon x-large class="mx-4" @click="borrar(fianza)">
                <v-icon> mdi-delete </v-icon>
              </v-btn>
              <v-btn
              v-if="mixValidaScopesActions(2)"
              icon x-large class="mx-4" @click="editar(fianza)">
                <v-icon> mdi-pencil </v-icon>
              </v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ListadoFianzasContratoMobile',
  props: {
    listadoFianzas: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    editar(fianzaContrato) {
      eventBus.$emit('editar-fianza-contrato', fianzaContrato);
    },
    borrar(fianzaContrato) {
      eventBus.$emit('eliminar-fianza-contrato', fianzaContrato);
    },
  },
};
</script>

<style lang="scss">
</style>
